import { Engine, Actor, Color, Vector, CollisionType, Animation, SpriteSheet, vec } from 'excalibur';
import { Resources } from '../../resources';
import { collision_groups } from '../../scenes/level-one/collision_groups';
import { LevelOne } from '../../scenes/level-one/level-one';
import { range } from '../../util';
import { Enemy } from './enemy';

export class HeartShark extends Enemy {
    constructor(
        level: LevelOne,
    ) {
        super(
            level,
            100,
            8,
            Animation.fromSpriteSheet(
                SpriteSheet.fromImageSource({
                    image: Resources.heartSharkSide,
                    grid: {
                        rows: 3,
                        columns: 5,
                        spriteWidth: 672,
                        spriteHeight: 266,
                    },

                }),
                range(0, 14),
                57
            ),
            Animation.fromSpriteSheet(
                SpriteSheet.fromImageSource({
                    image: Resources.heartSharkTop,
                    grid: {
                        rows: 2,
                        columns: 6,
                        spriteWidth: 295,
                        spriteHeight: 540,
                    },

                }),
                range(0, 11),
                40
            )
        );
    }
}

export { Enemy }
